"use client";

import { useEffect, useRef, useState } from "react";

import { cx } from "@/utils/cx";

export default function DBAbstract() {
	const [isLoaded, setIsLoaded] = useState(false);
	const videoRef = useRef<HTMLVideoElement>(null);

	const reveal = () => setIsLoaded(true);

	useEffect(() => {
		const video = videoRef.current;
		if (!video) return;

		if (video.readyState >= 2) {
			reveal();
			return;
		}

		const onReady = () => reveal();
		video.addEventListener("loadeddata", onReady);
		video.addEventListener("loadedmetadata", onReady);
		video.addEventListener("canplay", onReady);
		video.addEventListener("playing", onReady);
		video.addEventListener("error", onReady);

		const timeoutId = window.setTimeout(onReady, 3500);

		return () => {
			window.clearTimeout(timeoutId);
			video.removeEventListener("loadeddata", onReady);
			video.removeEventListener("loadedmetadata", onReady);
			video.removeEventListener("canplay", onReady);
			video.removeEventListener("playing", onReady);
			video.removeEventListener("error", onReady);
		};
	}, []);

	const posterSrc = "/assets/abstract-loop-poster.webp";

	return (
		<div
			aria-hidden
			className="dark-mode pointer-events-none absolute inset-0 z-0 bg-[linear-gradient(0deg,rgba(1,0,61,0.50)_0%,rgba(1,0,61,0.50)_100%)]"
		>
			<img
				src={posterSrc}
				alt=""
				fetchPriority="high"
				decoding="async"
				className="absolute inset-0 h-full w-full object-cover mix-blend-multiply"
			/>
			<video
				ref={videoRef}
				src="/assets/abstract-loop.mp4"
				poster={posterSrc}
				autoPlay
				muted
				loop
				playsInline
				preload="auto"
				className={cx(
					"absolute inset-0 h-full w-full object-cover mix-blend-multiply transition-opacity duration-1000",
					!isLoaded ? "opacity-0" : "opacity-100",
				)}
				onLoadedData={reveal}
				onLoadedMetadata={reveal}
				onCanPlay={reveal}
				onPlaying={reveal}
				onError={reveal}
			/>
		</div>
	);
}
